import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    SimulationProfile,
} from 'app/enums/label.enums'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

const config: SkyNetTableConfig = {
    name: 'SavedSimulationsTable',
    tabs: [{
        name: 'Transport Simulation',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'simulationNumber',
                labelKey: 'TransportSimulationView.simulationNumber',
            },
            {
                name: 'routeOriginAirportIataCode',
                filterField: 'routeOriginAirportIataCode',
                labelKey: 'TransportSimulationView.routeOriginAirportIataCode',
            },
            {
                name: 'routeDestinationAirportIataCode',
                filterField: 'routeDestinationAirportIataCode',
                labelKey: 'TransportSimulationView.routeDestinationAirportIataCode',
            },
            {
                name: 'createdBy',
                filterField: 'createdBy',
                labelKey: 'TransportSimulationView.createdBy',
            },
            {
                name: 'createdOn',
                labelKey: 'Damages.createdOn',
                componentName: 'DateTimeCell',
            },
            {
                name: 'simulationProfile',
                componentName: 'EnumValue',
                allowedValuesEnum: SimulationProfile,
                filterField: 'simulationProfile',
                labelKey: 'TransportSimulationView.simulationProfile',
            },
            {
                name: 'simulationFinalized',
                componentName: 'Boolean',
                labelKey: 'TransportSimulationView.simulationFinalized',
            },
        ],
    }],
}

export default config
